import { render, staticRenderFns } from "./MemberStatementModal.vue?vue&type=template&id=7a9b326f"
import script from "./MemberStatementModal.vue?vue&type=script&lang=js"
export * from "./MemberStatementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports